import circleIcon from "@mapbox/maki/icons/circle-stroked.svg";
import squareIcon from "@mapbox/maki/icons/square-stroked.svg";
class CustomDrawControls {
    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
        this._container.style.display = "flex";
        this._container.style.flexDirection = "row";
        const polygonSrc = `data:image/svg+xml,${encodeURIComponent(
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><polygon points="6,14 10,8 13,15" fill="none" stroke="black" stroke-width="1"/><circle cx="6" cy="14" r="1.2" fill="black"/><circle cx="10" cy="8" r="1.2" fill="black"/><circle cx="13" cy="15" r="1.2" fill="black"/></svg>'
        )}`;

        this._radialButton = this._createButton("Radial Search", circleIcon, "13px", "4px", () => {
            this._draw?.changeMode("draw_point");
        });
        this._rectangleButton = this._createButton("Draw Rectangle", squareIcon, "14px", "4px", () => {
            this._draw?.changeMode("draw_rectangle");
        });

        this._polygonButton = this._createButton("Draw Polygon", polygonSrc, "23px", "1px", () => {
            this._draw?.changeMode("draw_polygon");
        });

        this._trashButton = this._createButton("Delete", null, null, "0px", () => {
            this._draw?.trash();
        });
        this._trashButton.className = "mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_trash";

        this._container.appendChild(this._radialButton);
        this._container.appendChild(this._rectangleButton);
        this._container.appendChild(this._polygonButton);
        this._container.appendChild(this._trashButton);

        return this._container;
    }

    _createButton(title, iconSrc, iconSize, paddingTop, onClick) {
        const btn = document.createElement("button");
        btn.className = "mapbox-gl-draw_ctrl-draw-btn";
        btn.type = "button";
        btn.title = title;
        if (iconSrc) {
            const img = document.createElement("img");
            img.src = iconSrc;
            img.alt = title;
            img.style.width = iconSize;
            img.style.height = iconSize;
            img.style.paddingTop = paddingTop;
            btn.appendChild(img);
        }
        btn.onclick = onClick;
        return btn;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }

    setDraw(draw) {
        this._draw = draw;
    }
}

export default CustomDrawControls;
